<template>
  <poptip
    popper-class="notification-modal"
    :word-wrap="true"
    @on-popper-show="showPoptip"
    class="notifications"
    placement="bottom"
    width="440"
  >

    <taskbar-button
      icon="md-notifications"
      size="24"
      :show-badge="isNew"
      :click-handler="() => {}"
      tooltip-content="Уведомления"
    />

    <div class="notifications-pop" slot="content">
      <inline-loader v-if="loading" :loading="loading" />
      <history-list
        v-else-if="notifications.length"
        :actions="notifications"
        :all="true"
      />
      <div class="ms-help ms-nodata" v-else>Список уведомлений пуст</div>
    </div>
  </poptip>
</template>

<script>
import TaskbarButton from '@/components/parts/taskbar-button'
import InlineLoader from '../loaders/inline-loader'
import HistoryList from '@/components/history/history-list'

export default {
  components: {
    TaskbarButton,
    InlineLoader,
    HistoryList
  },
  data () {
    return {
      notifications: [],
      loading: false
    }
  },
  computed: {
    isNew () {
      return this.$store.state.notifications.isNew
    }
  },
  methods: {
    async showPoptip () {
      this.$store.commit('TOGGLE_IS_NEW', false)

      try {
        this.loading = true
        const url = `page/last_action`
        this.notifications = await this.$store.dispatch('GET_REQUEST', { url })
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less">
.notifications {
  margin-right: 8px;
  margin-left: 8px;
}

.notification-modal {
  .ivu-poptip-body {
    padding: 16px;
  }
  .ivu-poptip-arrow {
    display: none;
  }
  .ivu-poptip-body-content-word-wrap {
    text-align: left;
    white-space: normal;
  }
}
</style>
